<nav class="flex h-full flex-col">
  <!-- Logo zone -->
  <div class="flex flex-col gap-3 border-b border-greyscale-100 px-5 py-6">
    <a
      routerLink="/admin/company"
      class="h-[32px] w-[180px] bg-contain bg-left bg-no-repeat opacity-50 grayscale transition-opacity hover:opacity-70"
      style="background-image: url('/assets/greentripper-logo-dark.png');"
      aria-label="Greentripper - Go to company page"
    ></a>
    <span
      class="flex w-fit items-center gap-1.5 rounded-md bg-primary-600 px-2.5 py-1 text-xs font-semibold tracking-wider text-white"
    >
      <lucide-angular [img]="shieldIcon" [size]="14" />
      ADMIN PANEL
    </span>
  </div>

  <!-- Navigation -->
  <div class="scrollbar-thin scrollbar-thumb-greyscale-200 hover:scrollbar-thumb-greyscale-300 flex-1 overflow-y-auto overflow-x-hidden px-3 py-4">
    <div class="flex flex-col gap-1">
      @for (item of menuItems; track item.route) {
        <a
          [routerLink]="item.route"
          routerLinkActive="!bg-primary-100 !text-primary-700 [&>i]:!text-primary-700"
          class="flex items-center gap-3 rounded-lg px-4 py-3 text-greyscale-900 no-underline transition-all duration-200 hover:bg-primary-50 hover:text-primary-600 [&:hover>i]:text-primary-600"
        >
          <i [class]="item.icon" class="text-greyscale-500 transition-colors duration-200"></i>
          <span class="font-source-sans text-sm font-normal">{{ item.label }}</span>
        </a>
      }
    </div>
  </div>

  <!-- Return to platform button -->
  <div class="px-3 py-3">
    <button
      (click)="returnToUserPlatform()"
      class="flex w-full items-center gap-3 rounded-lg px-4 py-3 text-sm text-greyscale-600 transition-all duration-200 hover:bg-primary-50 hover:text-primary-600"
    >
      <i class="pi pi-arrow-left text-sm"></i>
      <span>{{ 'admin.menu.returnToPlatform' | transloco }}</span>
    </button>
  </div>

  <!-- User profile -->
  <div class="border-t border-greyscale-100 p-3">
    <app-connected-user-profile />
  </div>
</nav>
